exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".previews .search-header h1[data-v-22817ae4]{color:#006aff;font-size:3em;font-weight:500}.previews h2.type-header[data-v-22817ae4]{color:#006aff;margin-bottom:10px}.previews p.type-explanation[data-v-22817ae4]{font-size:16px}.previews .type-card[data-v-22817ae4]{background:#eaf7fc;padding:30px}", ""]);

// exports
